import { render, staticRenderFns } from "./WithholdingTaxFilesDialog.vue?vue&type=template&id=93654c9c&scoped=true&"
import script from "./WithholdingTaxFilesDialog.vue?vue&type=script&lang=js&"
export * from "./WithholdingTaxFilesDialog.vue?vue&type=script&lang=js&"
import style0 from "./WithholdingTaxFilesDialog.vue?vue&type=style&index=0&id=93654c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93654c9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VDivider,VIcon,VImg,VPagination,VProgressCircular,VRow})
